import { Component, OnInit, HostListener, Input, AfterViewInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import * as $ from "jquery";
import { DGB, MENU_PATH, USER_INFO } from "src/app/shared/constants/common.const";
import { AuthService } from "src/app/core/services/auth.service";
import { HttpClientService } from "src/app/core/services/http-client.service";
import { DataService } from "src/app/core/services/data.service";
import { ModalService } from "src/app/core/services/modal.service";
import { Util } from "src/app/shared/helpers/util";
import { environment } from "src/environments/environment";
import { HOM3500Component } from "src/app/modules/main/home/hom3500/hom3500.component";
import { PME0512Req } from "src/app/shared/models/umg/pme0512-req";
import { PME0512Res } from "src/app/shared/models/umg/pme0512-res";

@Component({
  selector: 'app-layout-main',
  templateUrl: './layout-main.component.html',
  styleUrls: ['./layout-main.component.css']
})
export class LayoutMainComponent implements OnInit, AfterViewInit, OnDestroy{
  @Input() modal: any;
  menuPath = MENU_PATH;
  sltLanguageList = false;
  sltSitemapList = false;
  util = new Util();
  timeCheckInterval: any;
  viewText: any;
  path: string;
  scroll = "";
  isScrollTop: boolean;
  userInfo: any;
  recordsTotal: any;
  isSubUser: boolean;
  isCheckMenu = true;
  menuRightData = [
    {
      programTypeCode: "",
      level1MenuCode: "",
      level2MenuCode: "",
      menuUseRightTypeCode: "",
      level1MenuDescription: "",
      level2MenuDescription: "",
      registerDate: "",
      changeDate: "",
      seqNo: "",
    },
  ];
  imageURL = "";
  langCode = this.translate.currentLang;
  langData = {
    en: { class: "eng", text: "English" },
    km: { class: "khmer", text: "ខ្មែរ" },
  };
  public imagePreviews: any;
  isOS: string;
  isHideMenuText = false;
  menutoggle = false;

  constructor(
    private dataService: DataService,
    private translate: TranslateService,
    private bizServer: HttpClientService,
    private authService: AuthService,
    private modalService: ModalService,
    private router: Router,
  ) {
    this.translate = translate;
  }

  ngOnInit() {
    this.userInfo = this.authService.getUserInfo();
    this.getComImage();
    this.langCode = this.util.getSecureStorage("langCode") || "en";
    this.translate.use(this.langCode);
    this.isSubUser = this.userInfo.subIDYn === "Y" ? true : false;
    this.authService.setLastEventTime();
    this.viewText = this.translate.instant("COMMON");
    this.timeCheckInterval = setInterval(() => {
      if (
        location.pathname !== "/login" &&
        this.authService.isEventTimeOver(environment.autoLogoutTime)
      ) {
        clearInterval(Number(this.timeCheckInterval));
        this.modalService.alert({
          content: this.viewText.LABEL.AUTO_LOGOUT1 + '\n' + this.viewText.LABEL.AUTO_LOGOUT2 + '\n' + this.viewText.LABEL.AUTO_LOGOUT3,
          btnText: this.viewText.BUTTON.OK,
          callback: (res: any) => {
            if (res.text !== '') {
              this.bizServer.httpPost("signout", {});
              this.authService.logout();
            }
          }
        });
      }
    }, 60000);

    this.dataService.isPreventScroll.subscribe( ( message ) => {
      setTimeout(() => {
        if ( message === "open" ) {
          this.scroll = "pop_open";
        } else if ( message === "close" ) {
            this.scroll = "";
        }
      });
    });

    this.dataService.companyData.subscribe( ( message ) => {
      if ( message === "company" ) {
        this.userInfo = this.authService.getUserInfo();
      } else if ( message.indexOf( "api/images/" ) !== -1 ) {
        this.userInfo = this.authService.getUserInfo();
        this.userInfo.corporateUserProfileImageURL = message;
        this.imageURL = message;
      }
    });
    document.addEventListener("localDataStorage", () => { }, false);

    this.menuscroll();

    if (window.navigator.appVersion.indexOf("Win") !== -1) {
      this.isOS = "Windows";
    } else if (window.navigator.appVersion.indexOf("Mac") !== -1) {
      this.isOS = "MacOS";
    } else {
      this.isOS = "";
    }
  }

  toggleClass() {
    this.menutoggle = !this.menutoggle;
  }

  getComImage() {
    this.dataService.imageData.subscribe( ( message ) => {
      if ( message.rawFile ) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.imagePreviews = { ...message, src: String(reader.result) };
        };
        reader.readAsDataURL(message.rawFile);
      }
    });
  }

  clearInquiryCondition() {
    this.util.removeSecureStorage("INQUIRY_CONDITION");
  }

  clearSearchCondition() {
    this.util.removeSecureStorage("SEARCH_CONDITION");
  }

  ngAfterViewInit(): void {
    this.userMenu();
    window.addEventListener("scroll", this.menuscroll, false);
  }

  onClickBody() {
    this.authService.setLastEventTime();
    this.sltLanguageList = false;
    this.sltSitemapList = false;
  }

  menuscroll() {
    if ( $ ( ".menuWrap" ).length > 0 && $( ".page_title .guideWrap" ).length > 0 ) {
      const sc = $(window).scrollTop();
      const menuH = $(".menuWrap").offset().top;
      const chat = $(".page_title .guideWrap").offset().top;

      if ( sc >= menuH ) {
        $(".menuWrap").addClass("fix");
      } else {
        $(".menuWrap").removeClass("fix");
      }

      if (sc + 56 >= chat) {
        $(".btn_livechat").addClass("fix");
        $(".btn_top").show();
      } else {
        $(".btn_livechat").removeClass("fix");
        $(".btn_top").hide();
      }
    }
  }

  @HostListener("window:storage", ["$event"])
  onstorage( event: any ) {
    if ( event.key === USER_INFO.STORE ) {
      if (location.pathname !== "/login" && !this.authService.hasSession()) {
        this.router.navigate(["/login"]);
      }
    }
  }

  logOut() {
    this.modalService.open({
      content: HOM3500Component,
    });
    this.dataService.scrollChange("open");
  }

  close() {
    this.modal.close();
    this.dataService.scrollMessage("close");
  }

  onOpenNew() {
    window.open("/main/home");
  }

  onScrollTop() {
    $(window).scrollTop(0);
  }

  onChangeLanguage(code: string) {
    this.langCode = code;
    this.translate.use(this.langCode);
    this.util.setSecureStorage("langCode", this.langCode);
  }

  contact() {
    window.open(DGB.CONTACT, "_blank");
  }

  careers() {
    window.open(DGB.CAREERS, "_blank");
  }

  facebook() {
    window.open(DGB.FACEBOOK, "_blank");
  }

  userMenu() {
    this.menuRightData = [];
    const reqTr = new PME0512Req();
    reqTr.body.customerNo = this.userInfo.customerNo;
    reqTr.body.channelTypeCode = this.userInfo.channelTypeCode;
    reqTr.body.loginUserID = this.userInfo.userID;
    this.bizServer.httpPost("PME0512", reqTr).subscribe((data) => {
      const resTr = data as PME0512Res;
      if ( this.bizServer.checkResponse( resTr ) ) {
        this.menuRightData = resTr.body.userMenuAccessList;
        this.menuRightData.map((item) => {
          Object.assign(item, {
            levelMenuSub: 'MCI1100',
          });
        });
        this.util.setSecureStorage("MENU_RIGHT", this.menuRightData);
        if ( this.userInfo.subIDYn === "N" ) {
          this.util.setSecureStorage("MENU_RIGHT", this.menuRightData);
        } else {
          this.util.setSecureStorage(
            "MENU_RIGHT",
            this.menuRightData.filter((item: any) => {
              return item.menuUseRightTypeCode === "2";
            })
          );
        }
      }
    });
  }

  isPermission(i: number): boolean {
    return (this.userInfo.subIDYn === "N" || this.menuRightData[i]?.menuUseRightTypeCode === "2");
  }

  isManagmentPermission(): boolean {
    return (
      this.isPermission(3)
    );
  }

  ngOnDestroy() {
    this.dataService.unsubscribe();
    this.util.removeSecureStorage('lastEventTime');
  }
}
